import { ethers } from 'ethers';

import { useProvider } from './useProvider';
import { useReadOnly } from './useReadOnly';
import { useSigner } from './useSigner';

type ReturnType = {
  provider?: ethers.JsonRpcProvider;
  signer?: ethers.Signer;
  signerOrProvider?: ethers.JsonRpcProvider | ethers.Signer;
};

export const useProviderOrSigner: () => ReturnType = () => {
  const readOnly = useReadOnly();
  const provider = useProvider();
  const signer = useSigner();

  return {
    provider,
    signer,
    signerOrProvider: signer && !readOnly ? signer : provider,
  };
};
